export default __webpack_public_path__ + "static/220-e134a7c5669a5fb261a016f6c3b44ee9.jpg";